module.exports = __webpack_public_path__ + "img/spaceInterest.8ffb8034.svg";